import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';

import Sidebar from './components/Sidebar';
import Header from './components/Header';

import Dashboard from './pages/Dashboard';
import PreSowing from './pages/PreSowing';
import SowingEmergence from './pages/SowingEmergence';
import Emergence from './pages/Emergence';
import GrowthTillering from './pages/GrowthTillering';
import BootingStage from './pages/BootingStage';
import RosetteStage from './pages/RosetteStage';
import Revisit from './pages/Revisit';
import CropsList from './pages/CropsList';
import Community from './pages/Community';
import Login from './components/Login';
import VegetationAnalysis from './pages/VegetationAnalysis';
import Finance from './pages/finance';
import Budget from './pages/Budget.js';
import BalancesHeat from './pages/balancesheat.js';
import './App.css';

function Layout() {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  return (
    <div className="app">
      {!isLoginPage && (
        <>
          <Sidebar />
          <div className="main-content">
            <Header />
            <div className="content-area">
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/crops" element={<CropsList />} />
                <Route path="/crop-stages/pre-sowing" element={<PreSowing />} />
                <Route path="/crop-stages/sowing-emergence" element={<SowingEmergence />} />
                <Route path="/crop-stages/emergence" element={<Emergence />} />
                <Route path="/crop-stages/growth-tillering" element={<GrowthTillering />} />
                <Route path="/crop-stages/booting" element={<BootingStage />} />
                <Route path="/crop-stages/rosette" element={<RosetteStage />} />
                <Route path="/crop-stages/revisit" element={<Revisit />} />
                <Route path="/VegetationAnalysis" element={<VegetationAnalysis />} />
                <Route path="/community" element={<Community />} />
                <Route path="/finance" element={<Finance />} />
                <Route path="/budget" element={<Budget />} />
                <Route path="/balancesheat" element={<BalancesHeat />} />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </div>
          </div>
        </>
      )}

      {isLoginPage && (
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" />} />

        </Routes>
      )}
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}
